'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getName = exports.getEmail = exports.getFamilyName = exports.getGivenName = exports.getDisplayName = exports.getId = exports.isActive = exports.isRealUserId = exports.isNotUserId = exports.isNotPublicUserId = exports.isStarterUserId = exports.isGuestUserId = exports.isPublicUserId = exports.isUserId = undefined;

var _lodash = require('lodash');

var _not = require('../../client/utils/milanoteLodash/not');

var _not2 = _interopRequireDefault(_not);

var _immutableHelper = require('../utils/immutableHelper');

var _userConstants = require('./userConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
var isUserId = exports.isUserId = function isUserId(testUserId) {
    return function (userId) {
        return userId === testUserId;
    };
};

// Constants


// Util
var isPublicUserId = exports.isPublicUserId = isUserId(_userConstants.PUBLIC_USER_ID);
var isGuestUserId = exports.isGuestUserId = isUserId(_userConstants.GUEST_USER_ID);
var isStarterUserId = exports.isStarterUserId = isUserId(_userConstants.STARTER_CONTENT_CREATOR_ID);

var isNotPublicUserId = exports.isNotPublicUserId = (0, _lodash.flow)([isPublicUserId, _not2.default]);
var isNotUserId = exports.isNotUserId = function isNotUserId(testUserId) {
    return (0, _lodash.flow)([isUserId(testUserId), _not2.default]);
};

var isRealUserId = exports.isRealUserId = function isRealUserId(userId) {
    return !isPublicUserId(userId) && !isGuestUserId(userId) && !isStarterUserId(userId);
};

var isActive = exports.isActive = function isActive(user) {
    return (0, _immutableHelper.prop)('status', user) === _userConstants.USER_STATUSES.ACTIVE;
};

var getId = exports.getId = (0, _immutableHelper.prop)('_id');
var getDisplayName = exports.getDisplayName = (0, _immutableHelper.propIn)(['name', 'displayName']);
var getGivenName = exports.getGivenName = (0, _immutableHelper.propIn)(['name', 'givenName']);
var getFamilyName = exports.getFamilyName = (0, _immutableHelper.propIn)(['name', 'familyName']);
var getEmail = exports.getEmail = (0, _immutableHelper.prop)('email');

var getName = exports.getName = function getName(user) {
    return getDisplayName(user) || getEmail(user) || 'Someone';
};


//////////////////
// WEBPACK FOOTER
// ./src/common/users/userHelper.js
// module id = 175
// module chunks = 0